export default "__VITE_ASSET__CwJ4RTUK__"